import React, { useMemo } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerPng from "leaflet/dist/images/marker-icon.png";
import shadowPng from "leaflet/dist/images/marker-shadow.png";

const DefaultIcon = L.icon({
  iconUrl: markerPng,
  shadowUrl: shadowPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

// ✅ Move map when locations change
function ChangeView({ center }) {
  const map = useMap();
  React.useEffect(() => {
    map.setView(center, 7);
  }, [center, map]);
  return null;
}

export default function ProjectLatLongPreview({
  locations = [],
  onLocationChange
}) {

  // ✅ Safe center (first valid location or fallback)
  const center = useMemo(() => {
    const valid = locations.find(
      (loc) => !isNaN(parseFloat(loc.lat)) && !isNaN(parseFloat(loc.lng))
    );

    return valid
      ? [parseFloat(valid.lat), parseFloat(valid.lng)]
      : [28.0, 77.0];
  }, [locations]);

  return (
    <MapContainer
      center={center}
      zoom={7}
      scrollWheelZoom={true}
      style={{ height: 300, width: "100%", borderRadius: 8 }}
    >
      <TileLayer
        attribution="&copy; OpenStreetMap contributors"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {/* ✅ Multiple markers */}
      {locations.map((loc, index) => {
        const lat = parseFloat(loc.lat);
        const lng = parseFloat(loc.lng);

        if (isNaN(lat) || isNaN(lng)) return null;

        return (
          <Marker
            key={index}
            position={[lat, lng]}
            draggable={true}
            eventHandlers={{
              dragend: (e) => {
                const { lat, lng } = e.target.getLatLng();

                onLocationChange?.(index, {
                  lat: lat.toFixed(6),
                  lng: lng.toFixed(6)
                });
              }
            }}
          >
            <Popup>
              Location {index + 1} <br />
              Lat: {lat} <br />
              Lng: {lng}
            </Popup>
          </Marker>
        );
      })}

      <ChangeView center={center} />
    </MapContainer>
  );
}
